import axios from 'axios'
import { urlDomain } from '../config/constant'

const apiDomain = urlDomain();

// Translates the inbound-call URL's `phone` param from the external
// vendor/dialer's own encryption to ours, so every other component can keep
// assuming decryptPII's default key. Node decrypts with vendorKey and
// re-encrypts with our key in one step — this always resolves to
// ciphertext, never the real number.
export const translateVendorPhone = async (phone) => {
  try {
    const res = await axios.post(`${apiDomain}/pii/translatePhone`, { phone });
    return res?.data?.phone ?? null;
  } catch (error) {
    console.error('Vendor phone translation failed:', error);
    return null;
  }
}
